module.exports = __webpack_public_path__ + "img/logo.97bd5b1c.png";